<template>
    <div class="column">
        <img class="image-preview" @click="toggleImgSize" style="cursor: pointer" @load="onImgLoad" :src="imageData">
    </div>
</template>

<script>

export default {
  name: 'CmpimageCard',
  props: {
    // 이 컴포넌트를 사용하는 페이지ID
    pageId: {
      type: String,
      required: true,
      default(){
          return '';
      }
    },
    imageFile: {
        type: Object,
        required: false,
        default(){
            return null;
        }
    },
  },
  computed: {
  },
  data() {
    return {
        imageData: "",
    }
  },
  mounted() {
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  watch: {
    imageFile: {
        handler(n, o) {
            if( this.isFileExist()){
            this.readImageFile();
            }
        },
        deep: true
    },
  },
  methods: {
    /**
     * 파일 존재유무 true/false 반환
     * @function isFileExist
     * @returns {Boolean}
     */
    isFileExist(){
        return !utils.isEmpty(this.imageFile.file);
    },
    toggleImgSize(){

    },
    onImgLoad(){

    },
    /**
     * 이미지 파일을 읽어서 base64로 인코딩 후 src 로 붙임
     * @function 
     */
    readImageFile(){
        // 이미지를 읽고 bse64 포맷으로 변환하기 위해 새로운 파일리더를 생성
        var reader = new FileReader();
        // 파일읽기 완료 이벤트 핸들러
        reader.onload = (e) => {
          this.imageData = e.target.result; // e.target 은 reader(FileReader)
        };
        reader.onabort = () => {
          console.log(reader.error);
        };

        // 데이터 URL로 파일읽기(base64 포맷으로 읽는다)
        reader.readAsDataURL(imageFile);
    },
    onShowImageViewerPopup( file){

      if( file.type.toUpperCase().startsWith("IMAGE") ){

        if( this.enableImageViewer){
          util.openLayerPopup('PGE_CMZ_00014', this.onPagePopupClose, {
            pageInitialData: { "file": file },
            size: 'sm',
            title:"Image Viewer"
          });
        }
      }
      else{
        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, file.name);
        }
        else {
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(file);
          link.target = '_blank';
          if(file.name) link.download = file.name;
          link.click();
        }
      }
    }
  },
};

</script>

<style lang="scss" scoped>
  /* Prevent the text contents of draggable elements from being selectable. */
[draggable] {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}
.column {
  height: 150px;
  width: 150px;
  float: left;
  border: 2px solid #666666;
  background-color: #ccc;
  margin-right: 5px;
  -webkit-border-radius: 10px;
  -ms-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 3px #000;
  -ms-box-shadow: inset 0 0 3px #000;
  box-shadow: inset 0 0 3px #000;
  text-align: center;
  cursor: move;
}
.column header {
  color: #fff;
  text-shadow: #000 0 1px;
  box-shadow: 5px;
  padding: 5px;
  background: -moz-linear-gradient(left center, rgb(0,0,0), rgb(79,79,79), rgb(21,21,21));
  background: -webkit-gradient(linear, left top, right top,
                               color-stop(0, rgb(0,0,0)),
                               color-stop(0.50, rgb(79,79,79)),
                               color-stop(1, rgb(21,21,21)));
  background: -webkit-linear-gradient(left center, rgb(0,0,0), rgb(79,79,79), rgb(21,21,21));
  background: -ms-linear-gradient(left center, rgb(0,0,0), rgb(79,79,79), rgb(21,21,21));
  border-bottom: 1px solid #ddd;
  -webkit-border-top-left-radius: 10px;
  -moz-border-radius-topleft: 10px;
  -ms-border-radius-topleft: 10px;
  border-top-left-radius: 10px;
  -webkit-border-top-right-radius: 10px;
  -ms-border-top-right-radius: 10px;
  -moz-border-radius-topright: 10px;
  border-top-right-radius: 10px;
}
.column.over {
  border: 2px dashed #000;
}

.img {
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
}
</style>
